/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChildSolid = (props: Props) => (
  <Icon viewBox="0 0 24 25" {...props}>
    <g fill="none">
      <path
        d="M6 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-3 12a3 3 0 1 1 6 0h2a5 5 0 0 0-10 0h2zm14-4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm-4 11c0-2.188 1.82-3.91 4-3.91 2.18 0 4 1.722 4 3.91h-8z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChildSolid as ChildSolid };
